<template>
    <div>
        <WorkoutIntro v-if="workout" :workout="workout" :christmasWorkout="christmasOverview === 'christmas' ? true : false"></WorkoutIntro>
    </div>
</template>

<script>
import * as api from '../api'
import WorkoutIntro from "@/components/WorkoutIntro.vue";
import store from '../store'
import { mapGetters } from "vuex"

import {addTrackingObject} from "@/utils/tracking"

export default {
    name: "WorkoutPreview",
    components: {
        WorkoutIntro,
    },
    data () {
        return {
            ...mapGetters(['activeWorkout']),
            id: this.$route.params.id,
            christmasOverview: this.$route.params.christmasOverview,
            kind: this.$route.params.kind,
            workout: false,
        }
    },
    computed: {
        isWorkout() {
            return this.$route.name === 'WorkoutOverview'
        }
    },
    mounted() {
        if(!this.activeWorkout() || this.activeWorkout().id !== this.id) {
            this.fetchData()
        }  else {
            this.workout = this.activeWorkout()
        }

        if(this.isWorkout) {
            addTrackingObject({subSection: "home", screenName: "detailsWorkout"}, {type: "workout", value: "web_workout_detail_page"});
        } else {
            addTrackingObject({subSection: "home", screenName: "detailsOpportunity"}, {type: "opportunity", value: "web_opportunity_open"});
        }
    },
    methods: {
        async fetchData() {
            try {
                let response
                if(this.isWorkout) {
                    response = await api.workout.get({id: this.id});
                } else {
                    response = await api.opportunities.get({id: this.id})
                }
                this.workout = response.data.data
                if(this.christmasOverview && this.kind) {
                    Object.assign(this.workout, {kind: this.kind});
                }
                store.commit('setActiveWorkout', this.workout)
            } catch (error) {
                console.error(error);
            }
        }
    }
}
</script>
